"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var index_1 = require("./index");
var Product_1 = require("../Product");
var TaxGroup_1 = require("../TaxGroup");
var Discount_1 = require("../Discount");
var CreatePaymentLine = /** @class */ (function () {
    function CreatePaymentLine(payment, type, discountPercentage) {
        var _this = this;
        this.type = index_1.PaymentLineType.PRODUCT;
        this.productId = null;
        this.categoryId = null;
        this.parentCategoryId = null;
        this.complianceCategoryId = null;
        this.productName = '';
        this.units = 1;
        this.unit = 'unit';
        this.inventorySubtracted = 1;
        // Used to prevent the inventorySubtracted value from going over what's available
        // Does not get sent to the API, strictly a client-side check
        this.maximumQuantity = null;
        this.pricePerUnit = 0;
        this.discountId = null;
        this.discountFixed = 0;
        this.discountPercentage = 0;
        this.discountLoyalty = 0;
        this.discountAdded = false;
        this.price = 0;
        this.barcode = null;
        this.shortDescription = null;
        this.batchId = null;
        // This is only used to show batchNumber and isn't required by the server
        this.batchNumber = undefined;
        this.sku = null;
        // this property is being used to record pricePerInventorySubtracted for bulk products.
        this.bulkPricePerInventorySubtracted = null;
        this.scannedBy = null;
        this.getProductDiscountLoyaltyCost = function (discountId) {
            if (discountId) {
                var targetProductDiscount = _this.payment.discounts.find(function (discount) { return discount.id === discountId; });
                if (targetProductDiscount) {
                    return targetProductDiscount.loyaltyCost;
                }
            }
        };
        this.calculateLineDiscountPrice = function (centValue) {
            var absoluteCentValue = Math.abs(centValue);
            if (_this.price <= absoluteCentValue) {
                absoluteCentValue = _this.product && _this.product.complianceCategoryId
                    ? _this.price - _this.inventorySubtracted
                    : _this.price;
            }
            return Math.round(absoluteCentValue) * -1;
        };
        this.setScannedBy = function (scannedBy) {
            _this.scannedBy = scannedBy;
        };
        this.getProRatedFixedCartDiscount = function (cdl) {
            if (cdl.discountType === Discount_1.DiscountTypes.PERCENT)
                return 0;
            var proRate = _this.getProRateForCartDiscount(cdl);
            var proRatedFixedCartDiscount = cdl.discountPrice * proRate;
            return proRatedFixedCartDiscount;
        };
        this.getProRatedPercCartDiscount = function (cdl) {
            if (cdl.discountType === Discount_1.DiscountTypes.FIXED)
                return 0;
            var proRate = _this.getProRateForCartDiscount(cdl);
            var proRatedPercCartDiscount = cdl.discountPrice * proRate;
            return proRatedPercCartDiscount;
        };
        this.getProRateForCartDiscount = function (cdl) {
            var discountedLineSubTotal = _this.payment.getSumOfDiscountedPricesByIncludedCartDiscount(cdl);
            switch (true) {
                case discountedLineSubTotal === 0:
                    return 0;
                default: {
                    var proRate = _this.productLineDiscountedPrice / discountedLineSubTotal;
                    return proRate;
                }
            }
        };
        this.payment = payment;
        this.type = type;
        this.discountPercentage = discountPercentage || 0;
        mobx_1.observe(this, function (change) {
            if (type === 'product' && discountPercentage !== 0) {
                var entityName = change.name.toString().toLowerCase().trim();
                // Price or discountPrice
                if (entityName.includes('price') || entityName.includes('discount')) {
                    _this.payment.updateCartDiscounts();
                }
            }
            if (_this.payment.paymentLineChangeCallback) {
                _this.payment.paymentLineChangeCallback(change);
            }
        });
    }
    Object.defineProperty(CreatePaymentLine.prototype, "availableLineDiscounts", {
        get: function () {
            return this.payment.availableProductDiscounts(this.productId, this.categoryId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "hasNonAutomaticDiscount", {
        /**
         * True when the line carries a discount that is NOT confirmed automatic:
         * - a custom cashier-entered discount (no discountId),
         * - a preset discount whose reference discount has `automatic: false`,
         * - a discount the payment cannot classify (discountId not in the payment's
         *   discount map, e.g. restored from a payment queue).
         * Such discounts must never be replaced by automatic discount re-evaluation.
         * Known limitation (accepted): an `automatic: true` discount that a cashier
         * picked manually is indistinguishable from an auto-applied one.
         */
        get: function () {
            if (this.discountId === null) {
                return this.discountFixed !== 0 || this.discountPercentage !== 0;
            }
            var referenceDiscount = this.payment.getDiscount(this.discountId);
            return !referenceDiscount || !referenceDiscount.automatic;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "isOverMaximumQuantity", {
        get: function () {
            if (this.maximumQuantity === null) {
                return false;
            }
            return this.inventorySubtracted > this.maximumQuantity;
        },
        enumerable: true,
        configurable: true
    });
    CreatePaymentLine.prototype.setBulkPricePerInventorySubtracted = function (bulkPricePerInventorySubtracted) {
        this.bulkPricePerInventorySubtracted = bulkPricePerInventorySubtracted;
    };
    CreatePaymentLine.prototype.setInventorySubtracted = function (inventoryToSubtract) {
        this.inventorySubtracted = parseFloat((inventoryToSubtract).toFixed(4));
        if (this.product) {
            this.units = parseFloat((inventoryToSubtract / this.product.inventorySubtractAmount).toFixed(4));
            this.price = Math.round(inventoryToSubtract * this.pricePerUnit);
        }
        else {
            this.units = inventoryToSubtract;
            this.price = Math.round(inventoryToSubtract * this.pricePerUnit);
        }
        this.updateLoyaltyCost(inventoryToSubtract);
    };
    CreatePaymentLine.prototype.setPricePerInventorySubtracted = function (pricePerInventorySubtracted) {
        this.pricePerUnit = pricePerInventorySubtracted;
        this.price = pricePerInventorySubtracted * this.inventorySubtracted;
    };
    CreatePaymentLine.prototype.setMaximumQuantity = function (maximumQuantity) {
        this.maximumQuantity = maximumQuantity;
    };
    CreatePaymentLine.prototype.setPrice = function (price) {
        this.price = price;
        this.pricePerUnit = Math.round(price / (this.units || 1));
    };
    Object.defineProperty(CreatePaymentLine.prototype, "depositFee", {
        get: function () {
            return (this.product && this.product.depositFee)
                ? this.product.depositFee * this.inventorySubtracted
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "taxLines", {
        get: function () {
            var _this = this;
            if (this.product) {
                if (this.product.name === Product_1.ProductType.TIP) {
                    return [];
                }
                var taxLinesToUse = this.product.taxes || [];
                if (this.payment.customerWithHistory && this.payment.customerWithHistory.customer.isTaxExempt) {
                    taxLinesToUse = taxLinesToUse.filter(function (taxLine) { return taxLine.exemptOverride; });
                }
                var proRatedDiscount_1 = this.cartDiscountPrice;
                // All taxes are applied AFTER the 20% BC vape tax (GST) is applied
                // BC gov't reference: https://www2.gov.bc.ca/assets/gov/taxes/sales-taxes/publications/notice-2019-005-sellers-vapour-products-pst-rate-increase.pdf
                var vapeTaxId_1 = TaxGroup_1.TaxIDs['Vape PST (BC)'];
                var matchingBCVapeTax = taxLinesToUse.find(function (tax) { return tax.id === vapeTaxId_1; });
                var bcVapeTaxAmount_1 = matchingBCVapeTax ? Math.round((this.productLineDiscountedPrice + proRatedDiscount_1) * (matchingBCVapeTax.percent / 100)) : 0;
                var taxLines = taxLinesToUse
                    .map(function (tax) {
                    var isVapeTax = tax.id === vapeTaxId_1;
                    var price = isVapeTax ? _this.price : _this.price + bcVapeTaxAmount_1;
                    var discountedPrice = price + _this.discountPrice + proRatedDiscount_1;
                    var amount = Math.round(discountedPrice * (tax.percent / 100));
                    return {
                        taxId: tax.id,
                        // Round at the line level. Shopify reference: https://help.shopify.com/en/manual/taxes/canada/canada-tax-manage#tax-rounding
                        // Should reduce net sale vs payment type discrepancies due to tax rounding
                        amount: amount,
                    };
                });
                return taxLines;
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "totalTaxAmount", {
        get: function () {
            return this.product
                ? this.taxLines.reduce(function (acc, curr) { return acc + curr.amount; }, 0)
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "cannabisWeight", {
        get: function () {
            if (this.product && this.product.complianceCategoryId) {
                return parseFloat(((this.product.cannabisWeight || 0) * this.inventorySubtracted).toFixed(2));
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    CreatePaymentLine.prototype.setBundleDiscountLine = function (bundleDiscountLine) {
        this.bundleDiscountLine = bundleDiscountLine;
    };
    CreatePaymentLine.prototype.updateLoyaltyCost = function (inventoryToSubtract) {
        if (!this.discountAdded || !this.discountId)
            return;
        var baseLoyaltyCost = this.getProductDiscountLoyaltyCost(this.discountId);
        if (baseLoyaltyCost) {
            this.loyaltyCost = baseLoyaltyCost * inventoryToSubtract;
        }
    };
    CreatePaymentLine.prototype.addPercentDiscount = function (percent, discountId, name) {
        this.discountPercentage = percent;
        this.discountFixed = 0;
        this.discountName = name;
        this.discountId = discountId;
        this.discountAdded = true;
        var baseLoyaltyCost = this.getProductDiscountLoyaltyCost(discountId);
        this.loyaltyCost = baseLoyaltyCost ? baseLoyaltyCost * (this.units) : undefined;
    };
    CreatePaymentLine.prototype.addFixedDiscount = function (centValue, discountId, name) {
        this.discountFixed = centValue;
        this.discountPercentage = 0;
        this.discountName = name;
        this.discountId = discountId;
        this.discountAdded = true;
        var baseLoyaltyCost = this.getProductDiscountLoyaltyCost(discountId);
        this.loyaltyCost = baseLoyaltyCost ? baseLoyaltyCost * (this.units) : undefined;
    };
    CreatePaymentLine.prototype.removeDiscount = function () {
        this.discountId = null;
        this.discountLoyalty = 0;
        this.discountFixed = 0;
        this.discountPercentage = 0;
        this.discountName = undefined;
        this.discountAdded = false;
        this.loyaltyCost = undefined;
    };
    Object.defineProperty(CreatePaymentLine.prototype, "discountPrice", {
        get: function () {
            if (this.type === index_1.PaymentLineType.LOYALTY && this.discountLoyalty) {
                return Math.abs(this.discountLoyalty) * -1;
            }
            if (this.discountFixed) {
                var centValue = Math.round(this.inventorySubtracted * this.discountFixed) * -1;
                return this.calculateLineDiscountPrice(centValue);
            }
            if (this.discountPercentage) {
                var centValue = Math.round(this.price * (Math.abs(this.discountPercentage) / 100)) * -1;
                return this.calculateLineDiscountPrice(centValue);
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "discountMessage", {
        get: function () {
            if (!this.discountAdded)
                return null;
            return this.discountName || "$" + (Math.abs(this.discountPrice) / 100).toFixed(2) + " off";
        },
        enumerable: true,
        configurable: true
    });
    CreatePaymentLine.prototype.setBarcode = function (barcode) {
        this.barcode = barcode;
    };
    CreatePaymentLine.prototype.setBatchId = function (batchId) {
        this.batchId = batchId;
    };
    CreatePaymentLine.prototype.setBatchNumber = function (batchNumber) {
        this.batchNumber = batchNumber;
    };
    Object.defineProperty(CreatePaymentLine.prototype, "networkTransferObject", {
        get: function () {
            return {
                type: this.type,
                productId: this.productId,
                productName: this.productName,
                units: this.units,
                unit: this.unit,
                inventorySubtracted: this.inventorySubtracted,
                price: Math.round(this.price),
                depositFee: this.depositFee,
                discountId: this.discountId,
                discountPrice: Math.round(this.discountPrice),
                discountMessage: this.discountMessage,
                cartDiscountPrice: this.cartDiscountPrice,
                loyaltyCost: this.loyaltyCost,
                barcode: this.barcode,
                shortDescription: this.shortDescription,
                batchId: this.batchId,
                sku: this.sku,
                scannedBy: this.scannedBy || undefined,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "productLineDiscountedPrice", {
        get: function () {
            var total = Math.round(this.price + this.discountPrice);
            // i.e. Loyalty
            if (this.type !== index_1.PaymentLineType.PRODUCT && this.type !== index_1.PaymentLineType.PAYMENT_FEE)
                return total;
            // Refund
            if (this.price < 0)
                return total;
            if (total <= 0) {
                return this.product && this.product.complianceCategoryId
                    ? 1 * this.units
                    : 0;
            }
            return total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "loyaltyDiscountProRate", {
        get: function () {
            if (this.bundleDiscountLine) {
                return 0;
            }
            var sumOfLineDiscountedProductPrices = this.payment.getSumOfNonBundledLineDiscountedProductPrices();
            return sumOfLineDiscountedProductPrices === 0
                ? 0
                : this.productLineDiscountedPrice / sumOfLineDiscountedProductPrices;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "sumOfProRatedLoyaltyDiscounts", {
        get: function () {
            if (this.bundleDiscountLine) {
                return 0;
            }
            var sumOfLoyaltyDiscounts = this.payment.getSumOfLoyaltyDiscounts();
            return this.loyaltyDiscountProRate * sumOfLoyaltyDiscounts;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "proRatedCartDiscountTotal", {
        get: function () {
            var _this = this;
            if (this.bundleDiscountLine) {
                return this.bundleDiscountLine.getProRatedBundleDiscount(this.productId);
            }
            return this.payment.nonBundleCartDiscountLines.reduce(function (acc, cdl) {
                var isNonStackableDiscount = cdl.referenceDiscount && cdl.referenceDiscount.isStackable === false;
                if (isNonStackableDiscount && _this.discountPrice < 0) {
                    return acc;
                }
                var shouldBeExcluded = cdl.shouldBeExcluded(_this.productId, _this.categoryId);
                var shouldBeTargeted = cdl.shouldBeTargeted(_this.productId, _this.categoryId);
                var sumOfProRatedCartDiscounts = _this.getProRatedFixedCartDiscount(cdl) + _this.getProRatedPercCartDiscount(cdl);
                if (cdl.discountMode === Discount_1.DiscountModes.ALL_PRODUCTS_AND_CATEGORIES) {
                    return shouldBeExcluded
                        ? acc
                        : acc + sumOfProRatedCartDiscounts;
                }
                if (cdl.discountMode === Discount_1.DiscountModes.SPECIFIC_PRODUCTS) {
                    var productIdTargeted = _this.productId === null
                        ? false
                        : cdl.targetedProductIds.includes(_this.productId);
                    return productIdTargeted
                        ? acc + sumOfProRatedCartDiscounts
                        : acc;
                }
                if (cdl.discountMode === Discount_1.DiscountModes.SPECIFIC_CATEGORIES) {
                    if (shouldBeExcluded) {
                        return acc;
                    }
                    return shouldBeTargeted
                        ? acc + sumOfProRatedCartDiscounts
                        : acc;
                }
                /**
                 * A discount should have been processed within the cases listed above.
                 * If all else fail, the safest and most obvious way to spot an issue is to simply not apply
                 * the cart discount
                 */
                return acc;
            }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePaymentLine.prototype, "cartDiscountPrice", {
        get: function () {
            if (this.type !== index_1.PaymentLineType.PRODUCT && this.type !== index_1.PaymentLineType.PAYMENT_FEE) {
                return 0;
            }
            return Math.round(this.sumOfProRatedLoyaltyDiscounts + this.proRatedCartDiscountTotal);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "payment", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "type", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "productId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "categoryId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "parentCategoryId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "complianceCategoryId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "product", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "productName", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "units", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "unit", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "inventorySubtracted", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "maximumQuantity", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "pricePerUnit", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "discountId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "bundleDiscountLine", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "discountFixed", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "discountPercentage", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "discountLoyalty", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "discountName", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "discountAdded", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "price", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "barcode", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "shortDescription", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "batchId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "batchNumber", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "sku", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "loyaltyCost", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePaymentLine.prototype, "scannedBy", void 0);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "availableLineDiscounts", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "hasNonAutomaticDiscount", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "isOverMaximumQuantity", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setInventorySubtracted", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setPricePerInventorySubtracted", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setMaximumQuantity", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setPrice", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "depositFee", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "taxLines", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "totalTaxAmount", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "cannabisWeight", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setBundleDiscountLine", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "addPercentDiscount", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "addFixedDiscount", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "removeDiscount", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "discountPrice", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "discountMessage", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setBarcode", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setBatchId", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setBatchNumber", null);
    __decorate([
        mobx_1.action
    ], CreatePaymentLine.prototype, "setScannedBy", void 0);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "networkTransferObject", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "productLineDiscountedPrice", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "loyaltyDiscountProRate", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "sumOfProRatedLoyaltyDiscounts", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "proRatedCartDiscountTotal", null);
    __decorate([
        mobx_1.computed
    ], CreatePaymentLine.prototype, "cartDiscountPrice", null);
    return CreatePaymentLine;
}());
exports.CreatePaymentLine = CreatePaymentLine;
var GiftCardStatus;
(function (GiftCardStatus) {
    GiftCardStatus["READY"] = "Ready";
    GiftCardStatus["ACTIVATED"] = "Activated";
    GiftCardStatus["RELOADED"] = "Reloaded";
})(GiftCardStatus = exports.GiftCardStatus || (exports.GiftCardStatus = {}));
var GiftCardActionType;
(function (GiftCardActionType) {
    GiftCardActionType["ACTIVATE"] = "Activate";
    GiftCardActionType["RELOAD"] = "Reload";
})(GiftCardActionType = exports.GiftCardActionType || (exports.GiftCardActionType = {}));
var CreateGiftCardPaymentLine = /** @class */ (function (_super) {
    __extends(CreateGiftCardPaymentLine, _super);
    function CreateGiftCardPaymentLine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = GiftCardStatus.READY;
        _this.isEditable = true;
        _this.setStatus = function (status) {
            _this.status = status;
        };
        _this.setRequiredAction = function (requiredAction) {
            _this.requiredAction = requiredAction;
        };
        _this.setGiftCardType = function (type) {
            _this.giftCardType = type;
        };
        _this.setIsEditable = function (isEditable) {
            _this.isEditable = isEditable;
        };
        _this.populateGiftCardParams = function (params) {
            if (params) {
                Object.keys(params).forEach(function (key) {
                    _this[key] = params[key];
                });
            }
        };
        _this.setCardNumber = function (cardNumber) {
            _this.cardNumber = cardNumber;
        };
        _this.setPin = function (pin) {
            _this.pin = pin;
        };
        return _this;
    }
    __decorate([
        mobx_1.observable
    ], CreateGiftCardPaymentLine.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardPaymentLine.prototype, "requiredAction", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardPaymentLine.prototype, "isEditable", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardPaymentLine.prototype, "cardNumber", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardPaymentLine.prototype, "giftCardType", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardPaymentLine.prototype, "pin", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardPaymentLine.prototype, "setStatus", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardPaymentLine.prototype, "setRequiredAction", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardPaymentLine.prototype, "setGiftCardType", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardPaymentLine.prototype, "setIsEditable", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardPaymentLine.prototype, "populateGiftCardParams", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardPaymentLine.prototype, "setCardNumber", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardPaymentLine.prototype, "setPin", void 0);
    return CreateGiftCardPaymentLine;
}(CreatePaymentLine));
exports.CreateGiftCardPaymentLine = CreateGiftCardPaymentLine;
var CreateProcessGiftCardPaymentLines = /** @class */ (function () {
    function CreateProcessGiftCardPaymentLines(payment) {
        this.giftCardPaymentLines = payment.giftCardPaymentLines;
    }
    Object.defineProperty(CreateProcessGiftCardPaymentLines.prototype, "wereAllGiftCardProcessesSuccessful", {
        get: function () {
            return this.giftCardPaymentLines.every(function (giftCard) { return (giftCard.status === GiftCardStatus.ACTIVATED) || (giftCard.status === GiftCardStatus.RELOADED); });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreateProcessGiftCardPaymentLines.prototype, "giftCardPaymentLines", void 0);
    __decorate([
        mobx_1.computed
    ], CreateProcessGiftCardPaymentLines.prototype, "wereAllGiftCardProcessesSuccessful", null);
    return CreateProcessGiftCardPaymentLines;
}());
exports.CreateProcessGiftCardPaymentLines = CreateProcessGiftCardPaymentLines;
var CreateTaxPaymentLine = /** @class */ (function () {
    function CreateTaxPaymentLine(taxId, amount) {
        this.taxId = taxId;
        this.amount = amount;
    }
    __decorate([
        mobx_1.observable
    ], CreateTaxPaymentLine.prototype, "taxId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTaxPaymentLine.prototype, "amount", void 0);
    return CreateTaxPaymentLine;
}());
exports.CreateTaxPaymentLine = CreateTaxPaymentLine;
// This is for barcode-validating payment lines
var ValidationLine = /** @class */ (function () {
    function ValidationLine(paymentQueueLine, maxQuantity) {
        var _this = this;
        this.quantityValidated = 0;
        this.isManuallyValidated = false;
        this.isValidationRequired = true;
        this.maxQuantity = 0;
        this.setValidationLine = function (validationLine) {
            _this.validationLine = validationLine;
        };
        this.setQuantityValidated = function (quantityValidate) {
            _this.quantityValidated = quantityValidate;
        };
        this.setIsManuallyValidated = function (isManuallyValidated) {
            _this.isManuallyValidated = isManuallyValidated;
        };
        this.setIsValidationRequired = function (isValidationRequired) {
            _this.isValidationRequired = isValidationRequired;
        };
        this.validationLine = paymentQueueLine;
        this.maxQuantity = maxQuantity;
    }
    Object.defineProperty(ValidationLine.prototype, "areAllquantitiesValidated", {
        get: function () {
            return this.maxQuantity === this.quantityValidated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationLine.prototype, "processedValidationLine", {
        get: function () {
            // This will be the paymentQueueLine that will be submitted to the cart
            var allQuantitiesManuallyValidated = this.areAllquantitiesValidated && this.isManuallyValidated;
            if (allQuantitiesManuallyValidated || !this.areAllquantitiesValidated) {
                return __assign({}, this.validationLine, { barcode: null });
            }
            return this.validationLine;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], ValidationLine.prototype, "validationLine", void 0);
    __decorate([
        mobx_1.observable // Quantity validated (manual validation & barcode validation)
    ], ValidationLine.prototype, "quantityValidated", void 0);
    __decorate([
        mobx_1.observable // Set to `true` if product manually validated
    ], ValidationLine.prototype, "isManuallyValidated", void 0);
    __decorate([
        mobx_1.observable
    ], ValidationLine.prototype, "isValidationRequired", void 0);
    __decorate([
        mobx_1.action
    ], ValidationLine.prototype, "setValidationLine", void 0);
    __decorate([
        mobx_1.action
    ], ValidationLine.prototype, "setQuantityValidated", void 0);
    __decorate([
        mobx_1.action
    ], ValidationLine.prototype, "setIsManuallyValidated", void 0);
    __decorate([
        mobx_1.action
    ], ValidationLine.prototype, "setIsValidationRequired", void 0);
    __decorate([
        mobx_1.computed // Quantity of barcode- & manually validated items per product
    ], ValidationLine.prototype, "areAllquantitiesValidated", null);
    __decorate([
        mobx_1.computed
    ], ValidationLine.prototype, "processedValidationLine", null);
    return ValidationLine;
}());
exports.ValidationLine = ValidationLine;
var CreateBarcodeValidation = /** @class */ (function () {
    function CreateBarcodeValidation() {
        var _this = this;
        this.validationLines = [];
        this.resetValidationLines = function () {
            _this.validationLines = [];
        };
        this.addValidationLine = function (paymentQueueLine, maxQuantity) {
            var paymentQueueValidationLine = new ValidationLine(paymentQueueLine, maxQuantity);
            _this.validationLines.push(paymentQueueValidationLine);
            return paymentQueueValidationLine;
        };
        this.removePaymentQueueLine = function (index) {
            _this.validationLines = _this.validationLines.filter(function (item, itemIndex) { return itemIndex !== index; });
        };
    }
    Object.defineProperty(CreateBarcodeValidation.prototype, "processedValidationLines", {
        get: function () {
            return this.validationLines.map(function (item) { return item.processedValidationLine; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateBarcodeValidation.prototype, "validatedLines", {
        get: function () {
            return this.validationLines
                .filter(function (item) { return item.areAllquantitiesValidated; })
                .map(function (item) { return item.validationLine; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateBarcodeValidation.prototype, "areAllLinesValidated", {
        get: function () {
            return this.validationLines.length === this.validatedLines.length;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreateBarcodeValidation.prototype, "validationLines", void 0);
    __decorate([
        mobx_1.action
    ], CreateBarcodeValidation.prototype, "resetValidationLines", void 0);
    __decorate([
        mobx_1.action
    ], CreateBarcodeValidation.prototype, "addValidationLine", void 0);
    __decorate([
        mobx_1.action
    ], CreateBarcodeValidation.prototype, "removePaymentQueueLine", void 0);
    __decorate([
        mobx_1.computed // Payment (queue) lines that were barcode- or manually validated
    ], CreateBarcodeValidation.prototype, "processedValidationLines", null);
    __decorate([
        mobx_1.computed // Array of payment (queue) lines where all product itmes are validated
    ], CreateBarcodeValidation.prototype, "validatedLines", null);
    __decorate([
        mobx_1.computed
    ], CreateBarcodeValidation.prototype, "areAllLinesValidated", null);
    return CreateBarcodeValidation;
}());
exports.CreateBarcodeValidation = CreateBarcodeValidation;
//# sourceMappingURL=CreatePaymentLine.js.map